export const defaultConfig = {
    PLATFORM: process.env.REACT_APP_PLATFORM || 'riskfritt',
    LOCATION: process.env.REACT_APP_LOCATION || 'SE',
    VERSION: process.env.REACT_APP_VERSION || '1.0',
    BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
}